import * as React from "react"
import { ActionCreatorWithPayload } from "@reduxjs/toolkit"
import { Box } from "@indeed/ifl-components"
import { useI18n } from "../../../common/utils/i18n-context"
import { useAppDispatch, useAppSelector } from "../../../common/utils/redux-helpers"
import { IDisplayItem } from "../feedback-form-model"
import { actions, requirementsSelector } from "../feedback-form-slice"
import { PreferenceItem, getPreferenceCategoryNamesMap } from "../preference-item"

export const NegativeQualificationsSelector: React.FC = () => {
    const dispatch = useAppDispatch()
    const jobRequirements = useAppSelector(requirementsSelector)
    const { gettext } = useI18n()

    const getPreferenceItem = (item: IDisplayItem, index: number, toggleSelected: ActionCreatorWithPayload<number>) => (
        <PreferenceItem
            id={`negative-qualifications-selector-item-${item.field}-${item.value}`}
            key={item.key}
            selected={item.selected}
            toggleSelect={() => {
                dispatch(toggleSelected(index))
            }}
            bodyText={item.selected ? item.selectedText : item.unselectedText}
            category={item.iconCategory}
            buttonAriaLabel={
                item.selected
                    ? gettext(
                          "Unhide jobs that require {0}",
                          `${getPreferenceCategoryNamesMap(gettext)[item.iconCategory]}: ${item.unselectedText}`
                      )
                    : gettext(
                          "Hide jobs that require {0}",
                          `${getPreferenceCategoryNamesMap(gettext)[item.iconCategory]}: ${item.unselectedText}`
                      )
            }
        />
    )

    return (
        <Box
            as="ul"
            sx={{
                listStyle: "none",
                paddingBlockEnd: 0,
                paddingBlockStart: 0,
                paddingInlineEnd: 0,
                paddingInlineStart: 0,
                inlineSize: "100%",
            }}
            id="negative-qualifications-options"
        >
            {jobRequirements.certifications.map((item, i) => getPreferenceItem(item, i, actions.toggleCertificationSelected))}
            {jobRequirements.licenses.map((item, i) => getPreferenceItem(item, i, actions.toggleLicenseSelected))}
            {jobRequirements.educations.map((item, i) => getPreferenceItem(item, i, actions.toggleEducationSelected))}
            {jobRequirements.languages.map((item, i) => getPreferenceItem(item, i, actions.toggleLanguageSelected))}
            {jobRequirements.skills.map((item, i) => getPreferenceItem(item, i, actions.toggleSkillSelected))}
        </Box>
    )
}
